import { createApp } from 'vue'
import SecondaryArticleSpots from './SecondaryArticleSpots'

const el = '.kb-component--secondary-article-spots'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((SecondaryArticleSpotsDOM) => {
            const props = {
                contentJson: SecondaryArticleSpotsDOM.dataset.contentjson
                    ? JSON.parse(SecondaryArticleSpotsDOM.dataset.contentjson)
                    : [],
                link: SecondaryArticleSpotsDOM.dataset.link
                    ? JSON.parse(SecondaryArticleSpotsDOM.dataset.link)
                    : null,
                carouselId: SecondaryArticleSpotsDOM.id
            }

            const component = createApp(SecondaryArticleSpots, props).use(Store)
            component.mount(SecondaryArticleSpotsDOM)
        })
    }
}
